const global = window

inputs.types.cell = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.format == 'mailto') {
        input.click(function () {
            clipboardCopy($(this).val())
            $(this).select()
        })
    }
    return data
}
